module.exports = __webpack_public_path__ + "static/media/Raju bhaiya-Model_page-0001.4fb76604.jpg";